import { Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'

import { CommonModule, NgFor, NgIf } from '@angular/common'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  forkJoin,
  map,
  Observable,
  of,
  Subject,
  take,
  takeUntil,
  tap
} from 'rxjs'

import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Actions, ofType } from '@ngrx/effects'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { PaginationComponent } from '../../../template/pagination/pagination.component'
import { LoaderComponent } from '../../../../shared/components/loader/loader.component'
import { environment } from '../../../../../environments/environment'
import { eps } from '../../../../services/url.service'
import { User } from '../../../../store/auth/auth.state'
import { LeavePolicyService } from '../../../../services/leave-policy.service'
import { UserService } from '../../../../services/user.service'
import { ToastrService } from 'ngx-toastr'
import { LeavePolicy } from '../../../../store/leave-policy/leave-policy.state'
import {
  deleteAssignedTo,
  loadAssignedTo,
  loadLeavePolicyById,
  loadUnAssignedTo,
  resetAssignedToState
} from '../../../../store/leave-policy/leave-policy.actions'
import {
  selectAssignedTo,
  selectLeavepolicy,
  selectTotalCount,
  selectUnassignedTo
} from '../../../../store/leave-policy/leave-policy.reducer'
import { selectUsers } from '../../../../store/user/user.reducer'
import { NgSelectModule } from '@ng-select/ng-select'
import { AssignedTo } from '../../../../store/role-permission/role-permission.state'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { SharedModule } from '../../../../shared/shared.module'

interface ExtendedUser extends User {
  validUpto: string | null
}

@Component({
  selector: 'app-leave-policy-detail',
  imports: [
    NgIf,
    NgFor,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    CapitalizePipe,
    PaginationComponent,
    LoaderComponent,
    NgSelectModule,
    HasPermissionDirective,
    SharedModule
  ],
  templateUrl: './leave-policy-detail.component.html',
  styleUrl: './leave-policy-detail.component.scss'
})
export class LeavePolicyDetailComponent implements OnInit {
  toastr = inject(ToastrService)
  private leavePolicyService = inject(LeavePolicyService)
  private userService = inject(UserService)
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private modalService = inject(NgbModal)
  eps = eps
  destroy$ = new Subject<void>()
  leavePolicy$: Observable<LeavePolicy | undefined | null> = of(undefined) // Initialize with a default value
  // assignedTo$ = this.store.select(selectAssignedTo)
  assignedTo$!: Observable<any[] | null | undefined>
  allUsers$ = this.store.select(selectUsers)
  unassignedTo$ = this.store.select(selectUnassignedTo)
  TempValidUpto!: Date | null
  selectedUsers: ExtendedUser[] = []
  totalCount$!: Observable<number>
  totalCount = 0
  totalUserCount$!: Observable<number>
  totalUserCount = 0
  currentPage = 1
  pageLimit = 10
  search = ''
  order = 'desc'
  pageLastRecord = 0
  defaultImg = '../../../../assets/img/user.jpg'
  apiEndpoint = environment.apiBaseUrl
  @ViewChild('assignUsersModal') assignUsersModal!: TemplateRef<any>
  @ViewChild('editBalanceModal') editBalanceModal!: TemplateRef<any>
  searchText = ''
  currentStep = 0
  policyId: string | null = ''
  employeeList = []
  selectedBusiness = ''
  assignedEmployees = []
  unassignedEmployees = []
  form!: FormGroup
  private fb = inject(FormBuilder)
  assignLeavePolicyform!: FormGroup
  policy!: LeavePolicy
  editAssignment!: AssignedTo
  updateLeavePolicyBalanceForm!: FormGroup
  DeleteId!: string
  employeeStatus: boolean | null = false
  private searchSubject = new Subject<string>()
  constructor(private actions$: Actions) {
    this.assignedTo$ = this.store.select(selectAssignedTo)
  }

  ngOnInit() {
    // this.store.dispatch(resetAssignedToState())
    this.employeeStatus = false
    this.policyId = this.route.snapshot.paramMap.get('id')

    if (this.policyId) {
      this.store.dispatch(loadLeavePolicyById({ id: this.policyId }))
      this.leavePolicy$ = this.store.select(selectLeavepolicy)
      this.loadAssignedTo()
      this.loadUnAssignedTo()
      this.leavePolicy$
        .pipe(
          filter((policy): policy is LeavePolicy => !!policy),
          takeUntil(this.destroy$)
        )
        .subscribe(policy => {
          this.policy = policy

          this.assignLeavePolicyform = this.fb.group({
            employeeIds: [[], Validators.required],
            leavePolicyId: [this.policyId, [Validators.required]]
            // businessId: [policy.businessId, Validators.required] // ✅ safe now
          })
        })

      // this.assignedTo$.pipe(takeUntil(this.destroy$)).subscribe(d => {
      //   this.totalCount = d?.length ?? 0
      //   this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
      // })

      // const params = `businessId=${encodeURIComponent(this.selectedBusinessId)}&disabled=false`
      // const params = ''
      // forkJoin({
      //   policyAssigned: this.leavePolicyService.assignedPolicyList(
      //     this.selectedBusiness!,
      //     this.policyId,
      //     this.currentPage,
      //     this.pageLimit
      //   ),
      //   employeeList: this.userService.getEmployees(params)
      // }).subscribe({
      //   next: ({ policyAssigned, employeeList }) => {
      //     const policyAssignedEmployeeIds = new Set(
      //       policyAssigned.assignedLeavePolicies.map((user: { userId: string }) => user.userId)
      //     )

      //     // Separate employees
      //     const assignedEmployees = employeeList.users.filter((user: { id: string }) =>
      //       policyAssignedEmployeeIds.has(user.id)
      //     )

      //     const unassignedEmployees = employeeList.users.filter(
      //       (user: { id: string }) => !policyAssignedEmployeeIds.has(user.id)
      //     )

      //     // Store them separately
      //     this.assignedEmployees = assignedEmployees
      //     this.unassignedEmployees = unassignedEmployees

      //     // Optionally: Set one of them for display
      //     this.employeeList = this.unassignedEmployees

      //     // You can also update the count if needed
      //     // this.totalCount = this.employeeList.length;
      //   },
      //   error: error => {
      //     this.toastr.error('Error: ' + error.message)
      //   }
      // })
    }

    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )

    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })

    this.totalUserCount$ = this.store.select(selectTotalCount).pipe(
      map(totalUserCount => totalUserCount || 0) // Default to 0 if totalCount is null
    )

    this.totalUserCount$.subscribe(count => {
      this.totalUserCount = count
      // this.updatePageLastRecord()
    })

    this.updateLeavePolicyBalanceForm = this.fb.group({
      balance: [null, [Validators.required]],
      reason: ['']
    })

    // Subscribe to debounced search input

    this.searchSubject.pipe(debounceTime(400)).subscribe(() => {
      this.currentPage = 1
      this.loadAssignedTo()
    })
  }

  //modal open
  openBusiness(content: unknown) {
    this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })
  }

  //modal close
  onClose() {
    this.currentStep = 1
    this.modalService.dismissAll()
    this.updateLeavePolicyBalanceForm.reset()
    // this.initializeForm()
    // this.policyList = []
  }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.loadAssignedTo() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  // loadAssignedTo() {
  //   const params: any = {}
  //   if (this.employeeStatus !== null) {
  //     params.disabled = this.employeeStatus
  //   }

  //   if (this.search) {
  //     // params.firstName = this.firstName
  //     params.search = this.search
  //   }
  //   console.log('params', params)
  //   const queryParams = new URLSearchParams(params)
  //   for (const key in params) {
  //     if (params[key] !== null && params[key] !== undefined) {
  //       queryParams.append(key, params[key])
  //     }
  //   }

  //   if (this.policyId) {
  //     this.store.dispatch(
  //       loadAssignedTo({
  //         leavePolicyId: this.policyId,
  //         params: queryParams.toString(),
  //         page: this.currentPage,
  //         limit: this.pageLimit
  //       })
  //     )
  //   }
  // }

  loadAssignedTo() {
    // console.log('[loadAssignedTo] called', {
    //   time: new Date().toISOString(),
    //   policyId: this.policyId,
    //   currentPage: this.currentPage,
    //   search: this.search,
    //   employeeStatus: this.employeeStatus
    // })
    if (!this.policyId) return
    const queryParams = new URLSearchParams()
    // ✅ Always send disabled if not null
    if (this.employeeStatus !== null) {
      queryParams.append('disabled', String(this.employeeStatus))
    }
    // ✅ Send search only if not empty
    if (this.search?.trim()) {
      queryParams.append('search', this.search.trim())
    }
    // console.log('Final Query:', queryParams.toString())
    this.store.dispatch(
      loadAssignedTo({
        leavePolicyId: this.policyId,
        params: queryParams.toString(),
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
  }

  loadUnAssignedTo() {
    const params: any = {}

    const queryParams = new URLSearchParams()
    for (const key in params) {
      if (params[key] !== null && params[key] !== undefined) {
        queryParams.append(key, params[key])
      }
    }

    if (this.policyId) {
      this.store.dispatch(
        loadUnAssignedTo({
          leavePolicyId: this.policyId,
          params: queryParams.toString(),
          page: this.currentPage,
          limit: this.pageLimit
        })
      )
    }
  }

  customSearchFnEmployee = (term: string, item: any) => {
    const fullName = `${item.firstName} ${item.lastName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  getErrorMessage(controlName: string): string | null {
    if (!this.form) return ''
    const control = this.form.get(controlName)
    if (!control) return '' // form not ready or control missing
    // console.log('control name', controlName)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  onAssign() {
    if (this.assignLeavePolicyform.valid) {
      // Handle form submission
      // console.log(this.form.value);
      const formData = {
        ...this.assignLeavePolicyform.value // Spread the form values
        // businessId: this.businessId, // Add the businessId
      }
      if (this.policyId) {
        this.leavePolicyService.assignPolicy(formData).subscribe({
          next: () => {
            this.toastr.success('SUCCESS', 'Leave Policy updated successfully!')
            this.loadAssignedTo()
            this.loadUnAssignedTo()
            this.onClose()
            // console.log('modal closed');
          },
          error: error => {
            this.toastr.error('Error: ' + error.error.message)
          }
        })
      }
    } else {
      // Mark all controls as touched to trigger validation error display
      this.form.markAllAsTouched()
    }
  }

  //modal open
  editBalance(content: unknown, assignment: any) {
    this.modalService.open(content, { scrollable: false, centered: true, size: 'md' })
    this.editAssignment = assignment
  }

  onUpdateBalance() {
    if (this.updateLeavePolicyBalanceForm.invalid || !this.editAssignment || !this.policyId) return

    const { balance, reason } = this.updateLeavePolicyBalanceForm.value

    const payload = {
      userId: this.editAssignment.user.id,
      leavePolicyId: this.policyId,
      balance: balance,
      reason: reason
    }

    this.leavePolicyService.updateLeaveBalance(payload).subscribe({
      next: () => {
        this.toastr.success('Leave balance updated successfully!')
        this.store.dispatch(loadLeavePolicyById({ id: this.policyId! }))
        this.loadAssignedTo()
        this.loadUnAssignedTo()

        this.onClose()
      },
      error: err => {
        this.toastr.error('Failed to update leave balance')
        console.error('Update Error:', err)
      }
    })
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  deleteAssignment(id: string) {
    this.store.dispatch(deleteAssignedTo({ id }))
  }

  openDelete(content: unknown, id: string) {
    this.DeleteId = id
    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmDelete() {
    if (this.DeleteId) {
      // this.leavePolicyService.delete(this.DeleteId).subscribe(() => {
      //   this.toastr.success('SUCCESS', 'Leave Policy assignment removed successfully!')
      // })
      this.store.dispatch(deleteAssignedTo({ id: this.DeleteId }))
      // this.loadAssignedTo()
      setTimeout(() => {
        this.loadAssignedTo()
      }, 300)
      this.loadUnAssignedTo()
      this.onClose()
    }
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadAssignedTo() // Load employees with new page limit
  }

  setCurrentPage() {
    this.currentPage = 1
  }

  onFilterChange() {
    this.searchSubject.next(this.search)
  }

  //---Assigning Users Ends---
}
